import React from "react";
import { LoginForm } from "../components";

function Login() {
  return (
    <div className="authPage__container">
      <LoginForm />
    </div>
  );
}

export default Login;
